<template>
  <v-dialog v-model="dialog" width="800">
    <v-card>
      <BarTitle title="Funções" @close="dialog = false"></BarTitle>

      <v-data-table
        v-model="selected"
        :headers="headers"
        :items="employeeRoles"
        :loading="loading_data_table"
        :search="search"
        show-select
        dense
      >
        <!-- <template v-slot:top>
          <v-toolbar flat>

            <v-spacer></v-spacer>

          </v-toolbar>
        </template> -->
      </v-data-table>

      <v-divider></v-divider>
      <v-card-actions>
        <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn :loading="loading_btn_sync" :disable="loading_btn_sync" large color="primary" text @click="sendGetEmployeeRole()"   v-bind="attrs" v-on="on"><v-icon>mdi-sync</v-icon>Sincronizar</v-btn>
      </template>
      <span>Carregar do ChessGestão</span>
    </v-tooltip>

        <v-spacer></v-spacer>
        <v-btn large color="secondary" text @click="dialog = false">fechar</v-btn>
        <v-btn :loading="loading_btn_add" :disabled="loading_btn_add" @click="addRoles()" large color="primary">adicionar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import BarTitle from "@/pages/Components/BarTitle.vue";
import { mapActions } from "vuex";
export default {
  components: {
    BarTitle,
  },
  props: {
    value: { type: Boolean },
    meterigMopId: { type: Number, required: true },
  },
  data() {
    return {
      selected: [],
      dialog: false,
      loading_data_table: false,
      loading_btn_sync: false,
      singleRole: true,
      headers: [
        { text: "#", value: "id" },
        { text: "DESCRIÇÃO", value: "description" },
      ],
      employeeRoles: [],
      search: "",
      loading_btn_add:false,
    };
  },

  watch: {
    value(val) {
      this.dialog = val;
      if (val) {
        this.selected = []
        this.employeeRoles = []
        this.initialize();
      }
    },
    dialog(val) {
      this.$emit("input", val);
    },
  },

  methods: {
    ...mapActions("MeteringMop", [
      "syncEmployeeRole",
      "getEmployeeRole",
      "addEmployeeRoles",
    ]),
    initialize() {
      this.loading_data_table = true;

      this.getEmployeeRole()
        .then((response) => {
          this.employeeRoles = response.data;
        })
        .finally(() => {
          this.loading_data_table = false;
        });
    },
    sendGetEmployeeRole() {
      this.loading_data_table = true;
      this.loading_btn_sync = true;
      this.syncEmployeeRole()
        .then((response) => {
          this.employeeRoles = response.data;
          this.$toast.success("Funções sincronizadas !");
        })
        .finally(() => {
          this.loading_data_table = false;
          this.loading_btn_sync = false;
        });
    },
    addRoles() {
      this.loading_btn_add = true;
      let data = {
        metering_mop_id: this.meterigMopId,
        employeeRoles: this.selected,
      };
      this.addEmployeeRoles(data).then((response) => {
        this.$emit("metering_mop_employee_role", response.data);
        this.dialog = false
      }).finally(()=>{
        this.loading_btn_add = false
      })
    },
  },
};
</script>

<style scoped>
h3 {
  margin-bottom: 8px;
}
</style>
